import { useState } from 'react';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { ExternalLink } from 'lucide-react';
import { MERCH_CONFIG } from './GameData';

export const MerchSection = () => (
  <section className="py-12 sm:py-20 px-4 bg-gradient-to-b from-transparent via-blue-900/20 to-transparent">
    <div className="max-w-7xl mx-auto">
      <MerchHeader />
      <div className="max-w-2xl mx-auto">
        <ProductCard />
      </div>
    </div>
  </section>
);

const MerchHeader = () => (
  <div className="text-center mb-12">
    <h2 className="text-4xl sm:text-5xl md:text-6xl font-black game-show-text mb-4">
      GET THE MERCH!
    </h2>
    <p className="text-xl sm:text-2xl text-blue-300 font-bold">
      Meet Game Show Monkey #1! More designs coming soon...
    </p>
  </div>
);

const ProductCard = () => {
  const [imageLoaded, setImageLoaded] = useState(false);

  return (
    <Card className="merch-card border-4 overflow-hidden">
      <CardContent className="p-0">
        <ProductImage imageLoaded={imageLoaded} onLoad={() => setImageLoaded(true)} />
        <ProductInfo />
      </CardContent>
    </Card>
  );
};

const ProductImage = ({ imageLoaded, onLoad }) => (
  <div className="relative bg-black">
    {!imageLoaded && (
      <div className="aspect-square flex items-center justify-center">
        <div className="loading-spinner"></div>
      </div>
    )}
    <img 
      src={MERCH_CONFIG.image}
      alt="This Is A Game Show T-Shirt"
      className={`w-full h-auto transition-opacity duration-500 ${imageLoaded ? 'opacity-100' : 'opacity-0'}`}
      onLoad={onLoad}
    />
  </div>
);

const ProductInfo = () => (
  <div className="p-6 sm:p-8 bg-gradient-to-br from-gray-300 via-gray-200 to-blue-200">
    <h3 className="text-2xl sm:text-3xl font-black mb-4 text-black">
      THIS IS A GAME SHOW T-SHIRT
    </h3>
    <p className="text-lg text-black/90 mb-6 font-bold">
      Official Ciro Game Show merchandise featuring Game Show Monkey #1!
    </p>
    <a 
      href={MERCH_CONFIG.purchaseLink}
      target="_blank"
      rel="noopener noreferrer"
      className="block w-full"
    >
      <Button 
        size="lg" 
        className="w-full text-xl font-black py-6 bg-black hover:bg-gray-900 text-white border-4 border-white pulse-button"
      >
        <ExternalLink className="mr-2 w-6 h-6" />
        BUY NOW ON EBAY
      </Button>
    </a>
  </div>
);
